var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { Data, Member, Membership } from 'aigens-ng-core';
import { TermsConditionsPage } from '../../dialogs/terms-conditions/terms-conditions';
import { MobileBasePage } from '../../core/base/mobile-base-page';
import { Injector, OnInit } from '@angular/core';
import { RouteTable } from '../../core/route-table';
import { version } from '../../../../package.json';
import { LanguageChoice } from 'src/app/shared/components/language_choice/language_choice';
import { preloaderFinished } from '../../../preloader';
import { IsLoginMemberDialogs } from 'src/app/dialogs/is-login-member/is-login-member';
// import * as firebase from 'firebase/app';
// import * as firebaseui from 'firebaseui';
/**
 * Generated class for the ByodBrandSplashPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */
var ByodBrandSplashPage = /** @class */ (function (_super) {
    __extends(ByodBrandSplashPage, _super);
    function ByodBrandSplashPage(injector) {
        var _this = _super.call(this, injector) || this;
        _this.login = false;
        _this.slideOpts = {
            initialSlide: 0,
            speed: 400
        };
        _this.langs = [];
        _this.v = version;
        console.log('ByodBrandSplashPage');
        _this.brandId = _this.getNavParams('brandId');
        _this.courtId = _this.getNavParams('courtId');
        if (_this.courtId) {
            _this.orderService.courtId = _this.courtId;
            _this.orderService.isCourt = true;
            // tmp
            _this.configService.isCourt = true;
            _this.systemConfigService.getSystemCourtConfig(_this.courtId, function (result) {
                console.log('TCL: constructor -> result', result);
                if (!(result && result.data && result.data.colors))
                    return;
                var colors = result.data.colors;
                _this.themeService.setConfigTheme(colors);
            });
        }
        if (!_this.brandId && !_this.courtId) {
            _this.brandId = 5637145314197504;
            _this.navParams.data['brandId'] = _this.brandId;
        }
        var store = _this.getNavParams('store');
        _this.orderService.deviceId = _this.sessionService.getDeviceId();
        if (typeof store === 'object') {
            _this.store = store;
            // this.storeId = store.id;
            _this.setLang(_this.store);
        }
        else {
            // this.storeId = store;
        }
        var paid = _this.getNavParams('paid');
        if (!paid) {
            paid = _this.navigationService.getNavigationParams()['status'];
        }
        /*if(window.location.href.split("?").length > 1){
            var tmp = window.location.href.split("?")[1]
            let mpgsOBJ=new URLSearchParams(tmp);
            this.paymentStatus = mpgsOBJ.get("status");

        }*/
        var id = _this.brandId ? _this.brandId : _this.courtId;
        _this.genSetSession(id.toString(), paid ? function () {
            _this.openOrderSummary();
        } : null);
        if (_this.courtId) {
            console.log('setting court lang');
            var lang = 'en';
            _this.t.use(lang);
            _this.t.currentLang = lang;
            _this.configService.setLocale(lang);
        }
        return _this;
    }
    ByodBrandSplashPage.prototype.ngOnInit = function () {
        var _this = this;
        console.log('ByodBrandSplashPage ngOnInit');
        // this.menuController.swipeEnable(false, 'menu1');
        _super.prototype.ngOnInit.call(this);
        this.configService.getPreference('paymentInfo').then(function (info) {
            console.log('paymentInfo', info);
            if (info) {
                var orderId = info['orderId'];
                var paymentId = info['paymentId'];
                var lang = info['lang'];
                if (lang && !_this.t.currentLang) {
                    _this.t.use(lang);
                    _this.configService.setLocale(lang);
                }
                _this.configService.putPreference('paymentInfo', null);
            }
            // this.getBrand();
        });
        if (this.brandId) {
            this.getBrand();
        }
        else {
            this.getCourt();
        }
    };
    ByodBrandSplashPage.prototype.CJLogin = function (crmId) {
        var _this = this;
        // get member by card No
        var card = this.sdkConfigService.getMemberCardNo;
        var hold = this.sdkConfigService.isCrystalJade && card && crmId;
        if (this.sdkConfigService.isCrystalJade) {
            this.memberService.clear();
        }
        if (hold) {
            this.memberApiService.loginWithCardNo(card, crmId).subscribe(function (member) {
                var m = Data.toData(Member, member);
                var membership = Data.toData(Membership, member['membership'] || {});
                m.membership = membership;
                if (m && m.sessionId) {
                    _this.memberService.putMember(m);
                }
            }, function (err) {
                console.log('JJ: err', err);
                _this.showError(err);
            }, function () {
                _this.loading(false);
            });
        }
        else {
            this.loading(false);
        }
    };
    ByodBrandSplashPage.prototype.clickedSlide = function (text) {
        console.log('TCL: clickedSlide -> text', text);
        var url = 'https://www.hongkongairport.com/en/';
        switch (text) {
            case 'img1':
                break;
            case 'img2':
                break;
            case 'detail':
                break;
        }
        if (url) {
            window.open(url, '_blank');
        }
    };
    ByodBrandSplashPage.prototype.goToLogin = function () {
        if (this.memberService.getMember()) {
            if (this.systemConfigService.hideStampPage) {
                this.pushByName('ProfileCourtPage', {
                    brand: this.brand
                });
            }
            else {
                this.pushByName('MemberRewardCourtPage', {
                    brand: this.brand
                });
            }
        }
        else {
            this.pushByName('LoginCourtPage', {
                courtId: this.courtId,
                features: this.brand.features,
                brand: this.brand,
                country: this.getCourtCountry()
            });
        }
    };
    ByodBrandSplashPage.prototype.ionViewWillEnter = function () {
        _super.prototype.ionViewWillEnter.call(this);
        if (this.brand) {
            this.setTheme(this.brand, this.store);
            console.log('背景图', this.brand.getImage('logo', 360, false));
        }
    };
    ByodBrandSplashPage.prototype.ionViewWillLeave = function () {
        _super.prototype.ngOnDestroy.call(this);
        this.resetTheme();
    };
    ByodBrandSplashPage.prototype.presentPopover = function (ev) {
        var _this = this;
        var inputs = [];
        var langs = this.brand['languages'];
        if (langs && langs.length > 0) {
        }
        else {
            langs = this.readObject(this.brand, 'brand.stores[0].languages');
        }
        this.langs = langs;
        // let langNames = { 'zh': '繁體中文', 'zh-cn': '简体中文', 'en': 'English' };
        var langNames = this.configService.config.langNames;
        if (langs === null || langs.length === 0)
            return;
        var currentLang = this.t.currentLang;
        for (var _i = 0, langs_1 = langs; _i < langs_1.length; _i++) {
            var lang = langs_1[_i];
            inputs.push({
                type: 'radio',
                label: langNames[lang],
                value: lang,
                checked: currentLang === lang
            });
        }
        console.log(inputs);
        var params = {
            inputs: inputs, lang: currentLang,
            callBack: function (lang) {
                _this.t.use(lang);
                _this.configService.setLocale(lang);
            }
        };
        this.showPopoverController(LanguageChoice, params, ev, { backdropDismiss: true, showBackdrop: false });
    };
    ByodBrandSplashPage.prototype.getCourtCountry = function () {
        var stores = this.brand && this.brand.stores;
        var country;
        if (stores && stores.length > 0) {
            country = stores[0].country;
        }
        return country;
    };
    ByodBrandSplashPage.prototype.setLang = function (store) {
        var newLang = store.language;
        if (!newLang) {
            var langs = store.languages;
            if (langs && langs.length > 0) {
                var lang = langs[0];
                newLang = lang;
            }
        }
        if (newLang && this.t.currentLang !== newLang) {
            this.configService.setLocale(newLang);
            this.t.use(newLang);
        }
    };
    ByodBrandSplashPage.prototype.resetTheme = function () {
        var body = document.getElementsByTagName('BODY')[0];
        body.removeAttribute('id');
    };
    ByodBrandSplashPage.prototype.startClicked = function () {
        var _this = this;
        // need a flag
        if (this.brandId === 5753217711341568 || this.brandId === 5643682388639744) {
            if (this.brandId === 5643682388639744) {
                this.multOrderManager.enableMutlOrder = true;
            }
            this.pushByUrl(RouteTable['BrandStoreListPage'], { brand: this.brandId }, { relativeTo: this.route });
        }
        else if (this.courtId) {
            // if (hasmode) { 现在只做不带mode的
            if (this.systemConfigService.checkCourtMemberInStart && !this.memberService.getMember()) {
                this.checkMemberModal();
                return;
            }
            this.orderService.isCourt = true;
            this.pushByUrl(RouteTable['BrandStoreListPage'], { courtId: this.courtId }, { relativeTo: this.route });
            // push to the page to select the modo of dinein or takeaway
            // this.pushByUrl(RouteTable['DineinOrTakeawayPage'], { courtId: this.courtId }, { relativeTo: this.route });
        }
        else {
            this.configService.getPreference('ssp.isAgreeTerms').then(function (result) {
                // if (!result) {
                _this.openTermsModal(_this.brand, function (data) {
                    _this.googleAnalyticEventTrack('enter page');
                    _this.pushByUrl(RouteTable['BrandStoreListPage'], {
                        brand: _this.brandId,
                        stores: _this.brand.stores
                    }, { relativeTo: _this.route });
                }, TermsConditionsPage);
                /*} else {

                    this.push(BrandStoreListPage, { brand: this.brandId });
                }*/
            });
        }
    };
    ByodBrandSplashPage.prototype.checkMemberModal = function () {
        return __awaiter(this, void 0, void 0, function () {
            var input, modal;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        input = {
                            ok: function () { _this.goToLogin(); },
                            cancel: function () {
                                _this.pushByUrl(RouteTable['BrandStoreListPage'], { courtId: _this.courtId }, { relativeTo: _this.route });
                            }
                        };
                        return [4 /*yield*/, this.modalController.create({
                                component: IsLoginMemberDialogs,
                                componentProps: input,
                                showBackdrop: true,
                                backdropDismiss: true,
                                cssClass: 'check-court-islogin'
                            })];
                    case 1:
                        modal = _a.sent();
                        return [4 /*yield*/, modal.present()];
                    case 2:
                        _a.sent();
                        modal.onDidDismiss().then(function () {
                        });
                        return [2 /*return*/];
                }
            });
        });
    };
    ByodBrandSplashPage.prototype.languageClicked = function () {
        return __awaiter(this, void 0, void 0, function () {
            var inputs, langs, langNames, currentLang, _i, langs_2, lang, alert;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.googleAnalyticEventTrack('lang');
                        inputs = [];
                        langs = ['zh', 'zh-cn', 'en'];
                        langNames = { 'zh': '繁體中文', 'zh-cn': '简体中文', 'en': 'English' };
                        currentLang = this.t.currentLang;
                        for (_i = 0, langs_2 = langs; _i < langs_2.length; _i++) {
                            lang = langs_2[_i];
                            console.log(currentLang, lang);
                            inputs.push({
                                type: 'radio',
                                label: langNames[lang],
                                value: lang,
                                checked: currentLang === lang
                            });
                        }
                        return [4 /*yield*/, this.alertController.create({
                                header: this.t.instant('buttons.language'),
                                inputs: inputs,
                                buttons: [
                                    {
                                        text: this.t.instant('buttons.cancel'),
                                        role: 'cancel',
                                        handler: function (data) {
                                        }
                                    },
                                    {
                                        text: this.t.instant('buttons.ok'),
                                        handler: function (lang) {
                                            console.log(lang);
                                            // to do
                                            // this.googleAnalyticEventTrack( 'click', 'select-' + lang);
                                            if (lang === currentLang) {
                                                return;
                                            }
                                            _this.t.use(lang);
                                            _this.configService.setLocale(lang);
                                            _this.getBrand();
                                        }
                                    }
                                ]
                            })];
                    case 1:
                        alert = _a.sent();
                        alert.present();
                        return [2 /*return*/];
                }
            });
        });
    };
    ByodBrandSplashPage.prototype.openOrderSummary = function () {
        var _this = this;
        this.googleAnalyticEventTrack('order history');
        this.loading(true);
        var id = this.brandId ? this.brandId : this.courtId;
        this.configService.getPreference(id.toString() + '.session').then(function (session) {
            _this.loading(false);
            if (!session) {
                var subtitle = _this.t.instant('global.order-first');
                var confirm_1 = _this.t.instant('buttons.ok');
                var alert_1 = _this.alertController.create({
                    header: subtitle,
                    buttons: [confirm_1]
                });
                alert_1.then(function (data) { return data.present(); });
            }
            else {
                _this.orderService.session = session;
                if (_this.multOrderManager.enableMutlOrder || _this.courtId) {
                    var page = 'MultiOrderHistoryPage';
                    // TODO: remove history
                    _this.pushByName(page, { courtId: _this.courtId }).then(function () {
                        // this.navController.remove(removeIndex, 1);
                    });
                }
                else {
                    _this.pushByUrl(RouteTable['MultiOrderHistoryPage'], {}, { relativeTo: _this.route });
                }
            }
        });
    };
    ByodBrandSplashPage.prototype.getBrand = function () {
        var _this = this;
        this.loading(true);
        this.menuService.getBrand(this.brandId).subscribe(function (brand) {
            _this.loading(false);
            _this.brand = brand;
            _this.setTheme(_this.brand, null);
            preloaderFinished();
        }, function (err) { return console.error(err); }, function () {
            _this.loading(false);
            preloaderFinished();
        });
    };
    ByodBrandSplashPage.prototype.getCourt = function () {
        var _this = this;
        this.loading(true);
        this.menuService.getCourt(this.courtId).subscribe(function (brand) {
            _this.loading(false);
            _this.orderService.courtBrand = brand;
            _this.brand = brand;
            _this.login = brand && brand.features && brand.features.includes('login');
            _this.orderService.login = _this.login;
            if (brand['payments'] && brand['payments'].length > 0) { // set payments
                _this.multOrderManager.payments = brand['payments'];
            }
            var langs = _this.brand['languages'];
            if (langs && langs.length > 0) {
            }
            else {
                langs = _this.readObject(_this.brand, 'brand.stores[0].languages');
            }
            _this.memberService.country = _this.brand.stores[0].country;
            _this.langs = langs;
            _this.setTheme(_this.brand, null);
            _this.CJLogin(_this.brand.crmId);
            preloaderFinished();
        }, function (err) { return console.error(err); }, function () {
            _this.loading(false);
            preloaderFinished();
        });
    };
    ByodBrandSplashPage.prototype.gotoFAQ = function () {
        console.log('go to FAQ');
        if (this.courtId)
            this.pushByUrl(RouteTable['BrandFAQPage'], { courtId: this.courtId }, { relativeTo: this.route });
        else {
        }
    };
    ByodBrandSplashPage.prototype.isAccessPage = function () {
        return true;
    };
    ByodBrandSplashPage.prototype.pageName = function () {
        return '/byod-brand-splash';
    };
    ByodBrandSplashPage.prototype.backButtonClickBrand = function () {
        console.log('DirectBrandStoreListPage backButtonOkHandler');
        try {
            console.log('sdkConfigService.back');
            if (this.sdkConfigService.isAvailable()) {
                this.sdkConfigService.back();
            }
            else {
                _super.prototype.backButtonClick.call(this);
            }
        }
        catch (error) {
            console.error('backButtonOkHandler.back error:', error);
        }
    };
    return ByodBrandSplashPage;
}(MobileBasePage));
export { ByodBrandSplashPage };
